const $19d416a1dabe61c4$export$6fb729463a74e23 = 'https://www.npmjs.com/package';
const $19d416a1dabe61c4$var$NPM_REGISTRY_URL = 'https://registry.npmjs.com';
const $19d416a1dabe61c4$export$2e74004b635d08aa = `https://corsmirror.com/v1?url=${$19d416a1dabe61c4$var$NPM_REGISTRY_URL}`;
const $19d416a1dabe61c4$export$a3c4df769e264cca = 300;


/**
 * Adds class to DOM element.
 *
 * @param element - The element.
 * @param className - The class.
 * @returns - The element.
 */ function $d526951eb107ee9b$export$d2cf6cd1dc7067d3(element, className) {
    if (element.className.indexOf(className) === -1) element.className += ' ' + className;
    return element;
}
function $d526951eb107ee9b$export$c2255604a80b4506(element, className) {
    if (element.className.indexOf(className) > -1) element.className = element.className.replace(className, '').trim();
    return element;
}
function $d526951eb107ee9b$export$a41c68a4eb5ff164(element, property, value) {
    if (!element) throw new Error('The first argument must be an element');
    /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
    if (element[property] !== value) // @ts-ignore
    element[property] = value;
    /* eslint-enable @typescript-eslint/ban-ts-comment */ return element;
}
function $d526951eb107ee9b$export$307fb6e7cd9f153f(packageName) {
    if (/^[a-zA-Z0-9_-]+$/.test(packageName)) return packageName[0] !== '_';
    return false;
}
function $d526951eb107ee9b$export$8c7c179b1e9895e(element, type) {
    switch(type){
        case 'error':
            $d526951eb107ee9b$export$c2255604a80b4506(element, 'green');
            $d526951eb107ee9b$export$d2cf6cd1dc7067d3(element, 'red');
            $d526951eb107ee9b$export$a41c68a4eb5ff164(element, 'textContent', 'cancel');
            break;
        case 'success':
            $d526951eb107ee9b$export$c2255604a80b4506(element, 'red');
            $d526951eb107ee9b$export$d2cf6cd1dc7067d3(element, 'green');
            $d526951eb107ee9b$export$a41c68a4eb5ff164(element, 'textContent', 'check_circle');
            break;
        case 'broken':
            $d526951eb107ee9b$export$c2255604a80b4506(element, 'green');
            $d526951eb107ee9b$export$d2cf6cd1dc7067d3(element, 'red');
            $d526951eb107ee9b$export$a41c68a4eb5ff164(element, 'textContent', 'report_problem');
            break;
        default:
            $d526951eb107ee9b$export$c2255604a80b4506(element, 'red');
            $d526951eb107ee9b$export$c2255604a80b4506(element, 'green');
            $d526951eb107ee9b$export$a41c68a4eb5ff164(element, 'textContent', 'search');
            break;
    }
}
let $d526951eb107ee9b$var$timeout;
function $d526951eb107ee9b$export$61fc7d43ac8f84b0(callback, delay) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        clearTimeout($d526951eb107ee9b$var$timeout);
        $d526951eb107ee9b$var$timeout = setTimeout(()=>{
            callback.apply(this, args);
        }, delay);
    };
}


// cache DOM nodes
const $04177131cda29cd1$var$inputElement = document.getElementById('npc-package-name');
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $04177131cda29cd1$var$loadingElement = document.getElementById('npc-loading');
const $04177131cda29cd1$var$resultTextElement = document.getElementById('npc-result-text');
const $04177131cda29cd1$var$resultIconElement = document.getElementById('npc-result-icon');
/* eslint-enable @typescript-eslint/no-non-null-assertion */ // store input value
let $04177131cda29cd1$var$inputValue;
// check name when it is typed (with a debounce)
$04177131cda29cd1$var$inputElement.addEventListener('keyup', $04177131cda29cd1$var$onKeyup, false);
/**
 * Handles `keyup` event.
 *
 * @param event - The event handler.
 */ function $04177131cda29cd1$var$onKeyup() {
    const packageName = $04177131cda29cd1$var$inputElement.value.toLowerCase();
    // blank input
    if (!packageName) {
        (0, $d526951eb107ee9b$export$c2255604a80b4506)($04177131cda29cd1$var$loadingElement, 'is-active');
        (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', '');
        (0, $d526951eb107ee9b$export$8c7c179b1e9895e)($04177131cda29cd1$var$resultIconElement, 'default');
        $04177131cda29cd1$var$inputValue = '';
        return;
    }
    // check whether input has changed
    if (packageName === $04177131cda29cd1$var$inputValue) return;
    else $04177131cda29cd1$var$inputValue = packageName;
    // invalid package name
    if (!(0, $d526951eb107ee9b$export$307fb6e7cd9f153f)(packageName)) {
        (0, $d526951eb107ee9b$export$c2255604a80b4506)($04177131cda29cd1$var$loadingElement, 'is-active');
        (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', 'Invalid name.');
        (0, $d526951eb107ee9b$export$8c7c179b1e9895e)($04177131cda29cd1$var$resultIconElement, 'error');
        return;
    }
    // clear result and display loading spinner
    (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', '');
    (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultIconElement, 'textContent', '');
    (0, $d526951eb107ee9b$export$d2cf6cd1dc7067d3)($04177131cda29cd1$var$loadingElement, 'is-active');
    (0, $d526951eb107ee9b$export$61fc7d43ac8f84b0)(async ()=>{
        let response;
        let data;
        try {
            response = await fetch(`${(0, $19d416a1dabe61c4$export$2e74004b635d08aa)}/${encodeURIComponent(packageName)}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            data = await response.json();
            // package name is taken
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', 'Name is taken.');
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'href', `${(0, $19d416a1dabe61c4$export$6fb729463a74e23)}/${packageName}`);
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'target', '_blank');
            (0, $d526951eb107ee9b$export$d2cf6cd1dc7067d3)($04177131cda29cd1$var$resultTextElement, 'hover');
            (0, $d526951eb107ee9b$export$8c7c179b1e9895e)($04177131cda29cd1$var$resultIconElement, 'error');
        } catch (error) {
            if (error.status >= 500) {
                (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', 'Server error.');
                (0, $d526951eb107ee9b$export$8c7c179b1e9895e)($04177131cda29cd1$var$resultIconElement, 'broken');
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
        // remove loading spinner
        (0, $d526951eb107ee9b$export$c2255604a80b4506)($04177131cda29cd1$var$loadingElement, 'is-active');
        // package is available or unpublished
        if (response?.status === 404 || data?.time?.unpublished) {
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'textContent', 'Name is available.');
            (0, $d526951eb107ee9b$export$8c7c179b1e9895e)($04177131cda29cd1$var$resultIconElement, 'success');
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'href', '#');
            (0, $d526951eb107ee9b$export$a41c68a4eb5ff164)($04177131cda29cd1$var$resultTextElement, 'target', '');
            (0, $d526951eb107ee9b$export$c2255604a80b4506)($04177131cda29cd1$var$resultTextElement, 'hover');
        }
    }, (0, $19d416a1dabe61c4$export$a3c4df769e264cca))();
}


//# sourceMappingURL=npm-package-name-checker.6bc6f528.js.map
